import React from 'react'
import styled from 'styled-components'
import { graphql } from 'react-apollo'
import PropTypes from 'prop-types'
import Button from '../common/Button'
import LoadingButton from '../common/LoadingButton'
import DestroyOutstandingLoan from './queries/DestroyOutstandingLoan'

const Container = styled.div`
  border: 1px solid #b4b5b6;
  background: white;
  border-radius: 5px;
  width: 420px;
  padding: 30px;
  color: #666666;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`
const ButtonContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`
const Cancel = Button.extend`
  background: #b4b5b6;
  margin-right: 5px;
`
const Delete = styled(LoadingButton)`
  margin-left: 5px;
`
class DeleteConfirmationModal extends React.Component {
  constructor() {
    super()
    this.state = {
      isLoading: false
    }
  }
  static propTypes = {
    destroyOutstandingLoan: PropTypes.func.isRequired,
    financialReviewRefetch: PropTypes.func.isRequired,
    refetch: PropTypes.func.isRequired,
    rid: PropTypes.number.isRequired,
    toggleModal: PropTypes.func.isRequired
  }
  onDeleteClick = async () => {
    const { rid, destroyOutstandingLoan, refetch, financialReviewRefetch, toggleModal } = this.props
    try {
      await destroyOutstandingLoan({
        variables: {
          input: {
            rid
          }
        }
      })
      refetch()
      financialReviewRefetch()
      toggleModal()
    } catch (err) {
      console.error(err)
    }
  }
  render() {
    const { toggleModal } = this.props
    const { isLoading } = this.state
    return (
      <Container>
        <h3>Are you sure you want to delete this business debt?</h3>
        <ButtonContainer>
          <Cancel onClick={toggleModal}>
            Cancel
          </Cancel>
          <Delete loading={isLoading} onClick={this.onDeleteClick}>
            Delete
          </Delete>
        </ButtonContainer>
      </Container>
    )
  }
}
export default graphql(DestroyOutstandingLoan, {
  name: 'destroyOutstandingLoan'
})(DeleteConfirmationModal)
